





























import { Component, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import AddSharedFacilityForm from '@/components/Admin/Forms/AddSharedFacilityForm.vue';

@Component({
    components: {
        AddSharedFacilityForm,
    },
    computed: {
        ...mapGetters({}),
    },
})

export default class AddSharedFacility extends Vue {
    constructor() {
        super();
    }
}
